// src/pages/task/Task.tsx
import React from 'react'
import { Helmet } from 'react-helmet-async'
import classes from './Task.module.sass'
import { useTask, TaskFilter } from './useTask'
import { List } from './components/List'
import { TaskStatus } from '../../../common/types/enums'

const STATUS_OPTIONS = [
  { value: null, label: 'Все' },
  { value: TaskStatus.TAKEN, label: 'Взятые' },
  { value: TaskStatus.IN_PROGRESS, label: 'В пути' },
  { value: TaskStatus.ARRIVED, label: 'Прибыл' },
  { value: TaskStatus.DELIVERED, label: 'Доставлено' },
  { value: TaskStatus.CANCELLED, label: 'Отменено' },
]

export const Task = () => {
  const {
    tasks,
    loading,
    refreshing,
    loadingMore,
    hasMore,
    error,
    filter,
    setFilter,
    selectedClusterId,
    setSelectedClusterId,
    statusFilter,
    setStatusFilter,
    executorClusters,
    refresh,
    loadMore,
  } = useTask()

  return (
    <div className={classes.container}>
      <Helmet>
        <title>Задания</title>
        <meta name="description" content="Задания исполнителя" />
      </Helmet>

      <div className={classes.header}>Задания</div>

      <div className={classes.filters}>
        <div className={classes.filterGroup}>
          <div
            className={filter === TaskFilter.POOL ? classes.filterActive : classes.filter}
            onClick={() => setFilter(TaskFilter.POOL)}
          >
            Доступные
          </div>
          <div
            className={filter === TaskFilter.MY ? classes.filterActive : classes.filter}
            onClick={() => setFilter(TaskFilter.MY)}
          >
            Мои
          </div>
        </div>

        {executorClusters.length > 1 && (
          <div className={classes.selectWrapper}>
            <select
              value={selectedClusterId ?? ''}
              onChange={(e) => setSelectedClusterId(e.target.value ? Number(e.target.value) : null)}
            >
              <option value="">Все кластеры</option>
              {executorClusters.map((c) => (
                <option key={c.cluster.id} value={c.cluster.id}>
                  {c.cluster.name}
                </option>
              ))}
            </select>
          </div>
        )}

        {filter === TaskFilter.MY && (
          <div className={classes.selectWrapper}>
            <select
              value={statusFilter ?? ''}
              onChange={(e) => setStatusFilter(e.target.value ? Number(e.target.value) : null)}
            >
              {STATUS_OPTIONS.map((opt) => (
                <option key={String(opt.value)} value={opt.value ?? ''}>
                  {opt.label}
                </option>
              ))}
            </select>
          </div>
        )}

        {/* <button className={classes.refreshButton} onClick={refresh} disabled={refreshing}>
          {refreshing ? 'Обновление...' : 'Обновить'}
        </button> */}
      </div>

      <List
        tasks={tasks}
        loading={loading}
        loadingMore={loadingMore}
        hasMore={hasMore}
        error={error}
        onLoadMore={loadMore}
      />
    </div>
  )
}
